var map = {
	"./AWS.png": 140,
	"./ESG.svg": 141,
	"./Google.png": 142,
	"./Lekan-image.png": 48,
	"./MHL.jpeg": 143,
	"./github.png": 144,
	"./google_logo.png": 145,
	"./lakeside.png": 146,
	"./lekan.png": 50,
	"./mongo.png": 147,
	"./nysc.svg": 148,
	"./pen.png": 51,
	"./profile.png": 149,
	"./psm1.svg": 150,
	"./schlumberger.png": 151,
	"./scrum.png": 152,
	"./scrum.svg": 153,
	"./software.png": 52,
	"./ssec.png": 154,
	"./technology.png": 49,
	"./web.png": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;